import { ref } from 'vue';
import { useServerConfig } from './useServerConfig';
import { useRouter } from 'vue-router';
import { useGetUserInfo } from './useGetUserInfo';

export function useAssetManagement() {
  const { serverAddress } = useServerConfig();
  const router = useRouter();
  const { assets } = useGetUserInfo();

  const showActivePopup = ref(false);
  const activePopupInfo = ref({
    id: null,
    activating: false,
  });

  const setActivePopup = (assetid, activating) => {
    activePopupInfo.value.id = assetid;
    activePopupInfo.value.activating = activating;
    showActivePopup.value = true;
  };

  const updateActiveAsset = async (assetId, isActive) => {
    try {
      const response = await fetch(`${serverAddress.value}/resources/updateactiveasset`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ assetid: assetId, inactive: isActive }),
      });

      if (!response.ok) {
        throw response.status;
      }

      const data = await response.json();
      if (!data.success) throw data.error;

      return true;
    } catch (err) {
      console.error('Error updating asset:', err);
      if (err === 401) {
        router.push({ name: 'login' });
      } else {
        alert("There was an error while trying to update your asset's active state.");
      }
      return false;
    }
  };

  const activateAsset = async () => {
    const index = assets.value.findIndex((asset) => asset.id === activePopupInfo.value.id);
    if (index < 0) return false;

    const success = await updateActiveAsset(activePopupInfo.value.id, false);
    if (success) {
      assets.value[index].inactive = false;
      showActivePopup.value = false;
    }
    return success;
  };

  const deactivateAsset = async () => {
    const index = assets.value.findIndex((asset) => asset.id === activePopupInfo.value.id);
    if (index < 0) return false;

    const success = await updateActiveAsset(activePopupInfo.value.id, true);
    if (success) {
      assets.value[index].inactive = true;
      showActivePopup.value = false;
    }
    return success;
  };

  return {
    showActivePopup,
    activePopupInfo,
    setActivePopup,
    activateAsset,
    deactivateAsset,
  };
}
